export default __webpack_public_path__ + "static/media/darkSearchIcon.3892050b.svg";